import styles from "./SubmitButton.module.css";

import { useHistory } from "react-router-dom";

const SubmitButton = (props) => {
  const history = useHistory();

  let style = `${styles.submitButton} ${props.class} my-2 ${props.reducedFontSize && styles.reducedFontSize}`;

  // const handleClick = () => {
  //   const path = props.click();
  //   if (path) {
  //     console.log("path: ", path);
  //     history.push(path);
  //   }
  // }

  let button;
  if (!props.disabled) {
    button = (
      <button
        onClick={props.click}
        type={props.type ? props.type : "button"}
        // to={props.toLink ? props.toLink : "/"}
        className={`${style} ${props.className} text-center`}
        style={props.style}
      >
        {props.children}
      </button>
    );
  } else {
    button = (
      <button
        type={props.type ? props.type : "button"}
        className={`${style} ${props.className} text-center`}
        style={props.style}
        disabled={true}
      >{props.children}</button>
    );
  }

  return button;
};

export default SubmitButton;
